import { api } from '@cwd/lib/main';

export type RegisterAccountData = {
    Brand: undefined | string;
    Company: string;
    CompanySize: string;
    Currency: string;
    Email: string;
    Gclid: undefined | string;
    Msclkid: undefined | string;
    Name: string;
    Password: string;
    Phone: string;
    Referrer: undefined | string;
    SalesChannel: undefined | string;
    Status: undefined | string;
};

export async function registerAccount(data: RegisterAccountData): Promise<any> {
    console.log('data', data);
    return api.post('/Accounts/Register', data);
}
